export default __webpack_public_path__ + "static/media/bg.af5216d8.jpg";